import { createApi } from '@reduxjs/toolkit/query/react'

import { rtkBaseQuery } from 'Src/api'

export const productsApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'productsApi',
  tagTypes: ['Products', 'Product'],
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    listProducts: builder.query({
      query: (params) => {
        return {
          url: `/v1/products/`,
          method: 'GET',
          params
        }
      },
      providesTags: ['Products']
    })
  })
})

export const { useListProductsQuery } = productsApi

export default productsApi
